/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Folder controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetFolderByIdResponse, UpdateFolderRequest, GetFoldersResponse, CreateFolderRequest, CreateFolderResponse } from "../models";

@Injectable({ providedIn: "root" })
export class FolderService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getFolderById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetFolderByIdResponse>;
    getFolderById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetFolderByIdResponse>>;
    getFolderById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetFolderByIdResponse>>;
    getFolderById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Folder/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateFolder(id: number, updateFolderRequest: UpdateFolderRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateFolder(id: number, updateFolderRequest: UpdateFolderRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateFolder(id: number, updateFolderRequest: UpdateFolderRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateFolder(id: number, updateFolderRequest: UpdateFolderRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Folder/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateFolderRequest, requestOptions);
    }

    deleteFolder(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteFolder(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteFolder(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteFolder(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Folder/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getFolders(parentId?: number | null, searchText?: string | null, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetFoldersResponse>;
    getFolders(parentId?: number | null, searchText?: string | null, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetFoldersResponse>>;
    getFolders(parentId?: number | null, searchText?: string | null, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetFoldersResponse>>;
    getFolders(parentId?: number | null, searchText?: string | null, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Folder`;

        let params = new HttpParams();
        if (parentId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, parentId, 'parentId');
        }
        if (searchText != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchText, 'searchText');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createFolder(createFolderRequest: CreateFolderRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateFolderResponse>;
    createFolder(createFolderRequest: CreateFolderRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateFolderResponse>>;
    createFolder(createFolderRequest: CreateFolderRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateFolderResponse>>;
    createFolder(createFolderRequest: CreateFolderRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Folder`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createFolderRequest, requestOptions);
    }
}
